export const RECEIVE_API_ERROR = 'RECEIVE_API_ERROR';
export function receiveApiError(errorMessage) {
  return {
    type: RECEIVE_API_ERROR,
    errorMessage,
  };
}



// WEBPACK FOOTER //
// ./src/actions/errors.js